import { AvcResult } from '@vfde-sails/avc-core';
import { AdditionalPageOptions, BenefitsData } from '../interfaces/additionalPageOptions';
import { formatEuro, formatPrice } from './formatter';

/**
 * Get CMS config from additionalPageOptions
 */
export const getCMSConfig = () => window.additionalPageOptions as AdditionalPageOptions;

/**
 * Get Fiber object from window
 */
export const getFiberObject = () => window.preFiber;

/**
  * Get SAILS object property for fiber repo by 'key'
*/
export const getFiberObjectProperty = (key: string) => getFiberObject()?.[key];

/**
 * Set SAILS object property for fiber repo by 'key' and 'value'
 */
export const setFiberProperty = (key: string, value: any) => {
    if (!window.preFiber) {
        window.preFiber = {};
    }

    window.preFiber[key] = value;
};

/**
 * Returns tariffIds in an array for the provided productId
 *
 * @returns string[]
 */
export const getTariffIds = (): string[] => {
    return getCMSConfig().tariffIds && Object.values(getCMSConfig().tariffIds);
};

/**
 * Returns Object contain stepsLabel in an array and active step
 *
 */
export const getStepperData = () => {
    return {
        stepsLabels: getCMSConfig().stepper && Object.values(getCMSConfig().stepper.labels),
        activeStep: getCMSConfig().stepper.activeStep,
    };
};

const getRegioFeeBenefitData = (
    avcResult?: AvcResult
): BenefitsData | null => {
    const config = getCMSConfig();

    const { regioFeeBenefit } = config;

    const regioFee = avcResult?.selectedAvailable
        ? avcResult.selected.regioCharge
        : avcResult?.fastest?.regioCharge;

    const minimumRegioFee = regioFeeBenefit.minimumChargeEuro;

    if (!regioFee && !minimumRegioFee) {
        return null;
    }

    return {
        ...regioFeeBenefit,
        headline: formatEuro(formatPrice(regioFeeBenefit.headline, regioFee || minimumRegioFee)),
    };
};

/**
 * Returns data for the tariff benefits list
 *
 * @param tariffId string
 * @param avcResult result of the avc check
 * @returns BenefitsData[]
 */
export const getBenefitsData = (tariffId: string, avcResult?: AvcResult) => {
    const config = getCMSConfig();
    const benefits = Object.values(config.tariffBenefits || {});
    const availableBenefits = benefits.filter(benefit => Object.values(benefit.tariffs).includes(tariffId));
    const regioFeeBenefit = getRegioFeeBenefitData(avcResult);

    regioFeeBenefit && availableBenefits.push(regioFeeBenefit);

    return availableBenefits;
};
